import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const policies = {
  privacy: {
    title: 'Privacy Policy', intro: 'How information is handled by the current website application.',
    sections: [
      ['Information used by the website', 'The application stores information submitted for customer accounts, authentication, saved addresses, checkout, payments and order support.'],
      ['Account and order security', 'Passwords are stored as secure hashes. Access tokens, server-side validation and role-based authorization protect customer and administrator functions.'],
      ['Payment information', 'Card, UPI and net-banking credentials are handled by Razorpay checkout and are not stored by this website.'],
      ['Questions or requests', 'Contact customersupport@sanjeevigraceherbals.com for privacy questions relating to the website or an account.']
    ]
  },
  terms: {
    title: 'Terms and Conditions', intro: 'Operational conditions currently enforced by the application.',
    sections: [
      ['Products and availability', 'Only active, published and in-stock products can be purchased. Product price and stock are verified again by the server during checkout.'],
      ['Orders and payment', 'An order receives a unique order number and appears in the customer account. Online payment is confirmed only after secure signature verification.'],
      ['Product information', 'Product information is provided for general information and must be read together with the medical disclaimer and approved product label.'],
      ['Support', 'Contact customer support before purchase if any displayed product, price, availability or policy information needs clarification.']
    ]
  },
  shipping: {
    title: 'Shipping Policy', intro: 'How delivery information is recorded and displayed by the current application.',
    sections: [
      ['Shipping charge', 'Any shipping charge is displayed in the server-verified checkout total before the order is placed.'],
      ['Courier tracking', 'When an order is shipped, the administrator can record the courier company, AWB number, tracking link, shipping date and estimated delivery date.'],
      ['Delivery estimate', 'An estimated delivery date is shown only when it has been entered for that order. It is an estimate rather than a guaranteed delivery time.'],
      ['Order tracking', 'Customers can follow the stored order timeline from My Orders or the Track Order page.']
    ]
  },
  cancellation: {
    title: 'Cancellation Policy', intro: 'How cancellation is represented in the order-management system.',
    sections: [
      ['Requesting support', 'Contact customer support with the order number to request review of a cancellation.'],
      ['Order status', 'If a cancellation is approved and recorded, the order status and timestamp appear in the customer timeline. Reserved inventory is restored once.'],
      ['Completed delivery', 'A delivered order follows the refund-review workflow rather than being reopened as a cancellation.']
    ]
  },
  returns: {
    title: 'Return and Refund Policy', intro: 'How refund review and completion are tracked by the application.',
    sections: [
      ['Refund review', 'Contact customer support with your order number so the request can be reviewed.'],
      ['Refund completion', 'When a refund is completed through the applicable payment or business process, the administrator records Refunded status and a timestamp in the order timeline.'],
      ['Before returning a product', 'Please contact customer support before sending any product back. The team will explain the information required for review.']
    ]
  }
};

function PolicyPage({ type }) {
  const { translate } = useLanguage();
  const policy = policies[type];
  return <main className="commerce-page policy-page"><div className="container"><header className="commerce-heading"><p className="eyebrow">{translate('Customer information')}</p><h1>{translate(policy.title)}</h1><p>{translate(policy.intro)}</p></header><div className="policy-sections">{policy.sections.map(([title, text]) => <section key={title}><h2>{translate(title)}</h2><p>{translate(text)}</p></section>)}</div><div className="policy-support"><strong>{translate('Need clarification?')}</strong><p><Link to="/contact">{translate('Contact Sanjeevi Grace Herbals customer support')}</Link> {translate('before placing an order or returning a product.')}</p></div></div></main>;
}
export default PolicyPage;
